import { render, staticRenderFns } from "./planoBimestralInfantilPolivalencia.vue?vue&type=template&id=75d3b240"
import script from "./planoBimestralInfantilPolivalencia.vue?vue&type=script&lang=js"
export * from "./planoBimestralInfantilPolivalencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports